import React from 'react'
import ReactDOM from 'react-dom'
import './styles/css/index.css'
import { HashRouter } from 'react-router-dom'
import App from './components/App'
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from './registerServiceWorker'
unregister()
ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>
  , document.getElementById('root'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js